<div class="registration-layout">
    <div class="container-registration registration__wrapper">
        
        <router-outlet></router-outlet>
    </div>
</div>